export default {
      id: "euestudante-usage",
      viewBox: "0 0 286.59 65",
      url: "/assets/svg/" + "sprite.svg#euestudante-usage",
      toString: function () {
        return this.url;
      }
    }